import type { Fetcher } from 'swr'
import { del, get, post, patch } from './base'
import type { CommonResponse } from '@/models/common'
import type {
  TrainingTaskListResponse,
  CreateTrainingTaskRequest,
  TrainingTaskDetailResponse,
} from '@/models/train'
import type { TrainingTask } from '@/types/training'

export const fetchTrainingTaskList: Fetcher<
  TrainingTaskListResponse,
  { params?: Record<string, any> }
> = ({ params }) => {
  return get('trains', { params }) as Promise<TrainingTaskListResponse>
}

export const fetchTrainingTaskPodList = ({ id }: { id: string }) => {
  return get<Record<string, any>[]>(`trains/${id}/pods`)
}

export const fetchTrainingTaskDetail = (id: string) => {
  return get<TrainingTaskDetailResponse>(`trains/${id}`)
}

export const createTrainingTask = (request: CreateTrainingTaskRequest) => {
  return post('trains', {
    body: request,
  }) as Promise<TrainingTaskDetailResponse>
}

export const deleteTrainingTask = (id: string) => {
  return del(`trains/${id}`) as Promise<CommonResponse>
}

export const stopTrainingTask = (id: string) => {
  return post(`trains/${id}/stop`) as Promise<CommonResponse>
}

export const startTrainingTask = (id: string) => {
  return post(`trains/${id}/start`) as Promise<CommonResponse>
}

export const fetchTrainingTaskLog = (id: string) => {
  return get(`trains/${id}/log`) as Promise<string>
}
function incrementCopy(str: string) {
  const copyRegex = /-副本(\d*)$/
  const match = str.match(copyRegex)

  if (match) {
    const copyNum = match[1]
    if (copyNum === '') {
      return str.replace(copyRegex, '-副本1')
    } else {
      return str.replace(copyRegex, `-副本${Number(copyNum) + 1}`)
    }
  } else {
    return `${str}-副本`
  }
}
function incrementOutputModel(str: string) {
  const copyRegex = /-v(\d*)$/
  const match = str.match(copyRegex)

  if (match) {
    const copyNum = match[1]
    if (copyNum === '') {
      return str.replace(copyRegex, '-v1')
    } else {
      return str.replace(copyRegex, `-v${Number(copyNum) + 1}`)
    }
  } else {
    return `${str}-v1`
  }
}
export const cloneTrainingTask = (task: any) => {
  const {
    name,
    description,
    dataset_id,
    dataset_version_name,
    base_model_id,
    base_model_version_name,
    output_model,
    gpu_num,
    image_id,
    resource_selector,
    volume_mounts,
    output_model_disk_id,
    dataset_s3_path,
    output_model_type,
    output_model_s3_path,
    restart_policy,
    backoff_limit,
    cmd,
    args,
    env,
    working_dir,
    permission,
    type,
    is_template,
  } = task
  const data: any = {
    name: incrementCopy(name),
    description,
    dataset_id,
    dataset_version_name,
    base_model_id,
    base_model_version_name,
    output_model: incrementOutputModel(output_model),
    gpu_num,
    image_id,
    resource_selector,
    volume_mounts,
    output_model_disk_id,
    dataset_s3_path,
    output_model_type,
    output_model_s3_path,
    restart_policy,
    backoff_limit,
    cmd,
    args,
    env,
    working_dir,
    permission,
    type,
    is_template,
  }
  return createTrainingTask(data)
}

export const updateTrainingTask = ({
  id,
  data,
}: {
  id: string
  data: TrainingTask
}) => {
  return patch(`trains/${id}`, { body: data }) as Promise<CommonResponse>
}
